import { FeatureFlag } from '../FeatureFlag';

export const enableMultiIdeaSelect = new FeatureFlag({
    key: 'enable-multi-idea-select',
    defaultValue: false,
});
